import styled from 'styled-components';

import transactionBg from '../../assets/images/transaction_bg.png';

const StyledContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	pointer-events: none;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
`;

const StyledIconContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.05);

	img {
		width: 20px;
		height: 20px;
		z-index: 2;
		user-select: none;
		pointer-events: none;
		opacity: 0.25;
	}
`;

const StyledIconBg = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 40px;
	height: 40px;
	mask-position: center;
	mask-repeat: no-repeat;
	mask-image: url(${transactionBg});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-image: url(${transactionBg});
`;

const StyledDescriptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 2px;
`;

const StyledCurrency = styled.div<{ $icon?: string }>`
	width: 20px;
	height: 20px;
	mask-position: center;
	mask-repeat: no-repeat;
	mask-image: url(${({ $icon }) => $icon});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-image: url(${({ $icon }) => $icon});

	&.income {
		background-color: #77de38;
	}

	&.payment {
		background-color: #ff3737;
	}
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;

	img {
		opacity: 0.5;
	}
`;

export {
	StyledContainer,
	StyledCurrency,
	StyledDescriptionContainer,
	StyledIconBg,
	StyledIconContainer,
	StyledLeftContainer,
	StyledRightContainer,
};
